<div
  *ngIf="shouldRender()"
  [attr.aria-labelledby]="id + '-header'"
  [attr.id]="id"
  [attr.tabindex]="content?.tabIndex"
  [ngStyle]="{ display: active ? null : 'none' }"
  class="idp-tab-section"
  role="tabpanel"
>
  <ng-content></ng-content>
</div>
